module.exports = __webpack_public_path__ + "img/vsuite-logo.f81cd41c.png";